import React from 'react';
import clsx from 'clsx';
import { CircularSpinnerProps } from './tools/CircularSpinner.model';
import { ReactComponent as CircularSpinnerIcon } from 'common-assets/assets/icons/circular-spinner.svg';
import { Icon } from '../Icon/Icon';
import { useTranslation } from 'react-i18next';

import useStyles from './CircularSpinner.style';

export const CircularSpinner = ({
  size = "large",
  thickness = 6,
  inverted = false,
  classNameSpinner,
  className,
  ariaLabel,
  disablePadding = false,
}: CircularSpinnerProps) => {
  const c = useStyles({ size, thickness, inverted, disablePadding });
  const [t] = useTranslation("components", { useSuspense: false });
  return (
    <div
      className={clsx(c.root, className, 'CircularSpinner')}
      data-type="ui/CircularSpinner"
      role="progressbar"
      aria-label={ariaLabel ?? t("circularSpinner.ariaLabel")}
    >
      <Icon className={clsx(c.spinner, classNameSpinner)}>
        <CircularSpinnerIcon />
      </Icon>
    </div>
  );
};